// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__11XUS","options":"AnswerScale_options__wXx6W","selected":"AnswerScale_selected__N_bkI"};